module.exports = __webpack_public_path__ + "static/media/dark-motion-constellation-performance-analysis.056a021.mp4";